import moment from 'moment-timezone';

export const state = {
  isOrgActive: true,
  calendarDate: null,
  todaysDate: moment().format(),
  overviewScrollPositionTop: null,
  overviewScrollPositionLeft: null,
};
